/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAgentModerationInfo } from '../agent_moderation_info/AgentModerationInfo';
import type { ISocialNetwork } from '../social_network_type/SocialNetwork';
import type { ISocialProfiles } from '../social_profile_type/SocialProfiles';
import type { IPhone } from '../phone/Phone';
import type { IParticipation } from '../participation/Participation';

export interface IAgentForCardV3 {
  /** Время регистрации на ЦИАН **/
  age: string;
  /** Включены ли чаты **/
  isChatsEnabled: boolean;
  /** ID пользователя на Realty **/
  realtyUserId: number;
  /** Статус публикации **/
  status: EStatus;
  /** Статус пользователя **/
  userStatus: EUserStatus;
  /** Абсолютный URL до аватара **/
  avatarUrl?: TAgentForCardV3_AvatarUrl;
  /** Место работы, если тип агента специалист **/
  companyName?: TAgentForCardV3_CompanyName;
  /** Контактный email указанный агентом **/
  contactEmail?: TAgentForCardV3_ContactEmail;
  /** "обо мне" профиля агента **/
  description?: TAgentForCardV3_Description;
  /** Текстовое описание с какого кода работает **/
  experience?: TAgentForCardV3_Experience;
  /** Пользователь на тарифе "Застройщик" **/
  isDeveloper?: TAgentForCardV3_IsDeveloper;
  /** Аватар мастер агента **/
  miniAvatarUrl?: TAgentForCardV3_MiniAvatarUrl;
  /** Информация от модерации **/
  moderationInfo?: TAgentForCardV3_ModerationInfo;
  /** Имя агента **/
  name?: TAgentForCardV3_Name;
  /** Регион работы **/
  regionsNames?: TAgentForCardV3_RegionsNames;
  /** Специализация **/
  skills?: TAgentForCardV3_Skills;
  /** Социальные сети через ID в них **/
  socialNetworks?: TAgentForCardV3_SocialNetworks;
  /** Социальные сети через ссылки на профиль **/
  socialProfiles?: TAgentForCardV3_SocialProfiles;
  /** Ссылка на вебсайт **/
  website?: TAgentForCardV3_Website;
  /** Подменный номер телефона **/
  ctPhoneNumber?: TAgentForCardV3_CtPhoneNumber;
  /** Номера телефонов **/
  phones?: TAgentForCardV3_Phones;
  /** Участвует в акции **/
  hasFairplay: boolean;
  /** Тип аккаунта **/
  accountType?: TAgentForCardV3_AccountType;
  /** Skype пользователя **/
  skype?: TAgentForCardV3_Skype;
  /** Участия в профессиональных объединениях **/
  participations?: IParticipation[];
}

export enum EStatus {
  /** Скрыто **/
  Hidden = 'hidden',
  /** Опубликовано **/
  Published = 'published',
}
export enum EUserStatus {
  /** Активный **/
  Active = 'active',
  /** Заблокированный **/
  Blocked = 'blocked',
  /** Удаленный **/
  Deleted = 'deleted',
}
export type TAgentForCardV3_AvatarUrl = null | string;

export type TAgentForCardV3_CompanyName = null | string;

export type TAgentForCardV3_ContactEmail = null | string;

export type TAgentForCardV3_Description = null | string;

export type TAgentForCardV3_Experience = null | string;

export type TAgentForCardV3_IsDeveloper = null | boolean;

export type TAgentForCardV3_MiniAvatarUrl = null | string;

export type TAgentForCardV3_ModerationInfo = null | IAgentModerationInfo;

export type TAgentForCardV3_Name = null | string;

export type TAgentForCardV3_RegionsNames = null | string[];

export type TAgentForCardV3_Skills = null | string[];

export type TAgentForCardV3_SocialNetworks = null | TAgentForCardV3_SocialNetworks_1;

export type TAgentForCardV3_SocialNetworks_1 = ISocialNetwork[];

export type TAgentForCardV3_SocialProfiles = null | TAgentForCardV3_SocialProfiles_1;

export type TAgentForCardV3_SocialProfiles_1 = ISocialProfiles[];

export type TAgentForCardV3_Website = null | string;

export type TAgentForCardV3_CtPhoneNumber = null | string;

export type TAgentForCardV3_Phones = null | TAgentForCardV3_Phones_1;

export type TAgentForCardV3_Phones_1 = IPhone[];

export type TAgentForCardV3_AccountType = null | EAccountType;

export enum EAccountType {
  /** Агенство **/
  Agency = 'agency',
  /** Управляющая компания **/
  ManagementCompany = 'managementCompany',
  /** Отдел аренды **/
  RentDepartment = 'rentDepartment',
  /** Специалист **/
  Specialist = 'specialist',
}
export type TAgentForCardV3_Skype = null | string;
